import { StackView, Spinner } from '@planningcenter/tapestry-react';
import React from 'react';
import { Chat as Chat$1 } from 'stream-chat-react';
import { ChatApiProvider } from './chat_api_context.js';
import { ChatProvider } from './chat_context.js';
import { BlankStateView } from './components/blank_state_view.js';
import { ChannelDetailsView } from './components/channel_details_view/index.js';
import { ChannelListView } from './components/channel_list_view/index.js';
import { ChannelView } from './components/channel_view/index.js';
import { NewChatShortcutsView } from './components/new_chat_shortcuts_view.js';
import { NewGroupsChatView } from './components/new_groups_chat_view.js';
import { NewServicesChatView } from './components/new_services_chat_view.js';
import { BetaBadge } from './components/beta_badge.js';
import '@planningcenter/datetime-fmt';
import '../_virtual/moment.js';
import '@planningcenter/url';
import { useChatFilter } from './hooks/use_chat_filter.js';
import { useChatNavigation } from './hooks/use_chat_navigation.js';
import '@planningcenter/jolt-client';
import { useClient } from './hooks/use_client.js';
import { useTotalUnreadCount } from './hooks/use_total_unread_count.js';
import { DrawerHeader } from './vendor/topbar/components/drawer_header.js';
import { DrawerHeading } from './vendor/topbar/components/drawer_heading.js';
import { SwitchView } from './vendor/topbar/components/switch_view.js';

const ChatController = ({ client, closeDrawer, children, currentPath, currentPersonId, env, onChangePath, }) => {
    const { filterValues, setFilterValues } = useChatFilter();
    const [actionsOpenForChannel, setActionsOpenForChannel] = React.useState(false);
    const navigation = useChatNavigation({
        currentPath,
        onChangePath,
        setFilterValues,
    });
    const { markAllRead, markAllReadProcessing, refreshTotalUnreadCount, totalUnreadCount, } = useTotalUnreadCount({
        client,
        currentPersonId,
        env,
        isChannelListViewActive: navigation.isChannelListViewActive,
    });
    return (React.createElement(ChatProvider, { value: {
            actionsOpenForChannel,
            closeDrawer,
            currentPersonId,
            env,
            filterValues,
            markAllRead,
            markAllReadProcessing,
            navigation,
            refreshTotalUnreadCount,
            setActionsOpenForChannel,
            setFilterValues,
            totalUnreadCount,
        } },
        React.createElement(SwitchView, { activeIndex: navigation.activeIndex }, children)));
};
const ChatTool = ({ appName, closeDrawer, currentPath, env, chatStreamUser, hasConnectedPeople, onChangePath, userId: currentPersonId, }) => {
    const chatClient = useClient(chatStreamUser);
    return chatClient ? (React.createElement(ChatComponent, { chatClient: chatClient, closeDrawer: closeDrawer, env: env, hasConnectedPeople: hasConnectedPeople, appName: appName, currentPersonId: currentPersonId, currentPath: currentPath, onChangePath: onChangePath })) : (React.createElement(DrawerHeader, { closeDrawer: closeDrawer },
        React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1 },
            React.createElement(DrawerHeading, null, "Chat"),
            React.createElement(BetaBadge, null),
            React.createElement(Spinner, { color: "hsl(0 0% 62%)", thickness: 2, trackColor: "hsl(0 0% 97%)" }))));
};
const ChatComponent = ({ chatClient, closeDrawer, hasConnectedPeople, env, appName, currentPath, currentPersonId, onChangePath, }) => {
    return (React.createElement(Chat$1, { client: chatClient, theme: "str-chat__theme-light" },
        React.createElement(ChatApiProvider, { env: env },
            React.createElement(ChatController, { client: chatClient, closeDrawer: closeDrawer, currentPath: currentPath, currentPersonId: currentPersonId, env: env, onChangePath: onChangePath },
                React.createElement(ChannelListView, { closeDrawer: closeDrawer, client: chatClient, hasConnectedPeople: hasConnectedPeople, env: env, appName: appName, currentPersonId: currentPersonId }),
                React.createElement(NewChatShortcutsView, null),
                React.createElement(NewServicesChatView, null),
                React.createElement(NewGroupsChatView, null),
                React.createElement(ChannelView, null),
                React.createElement(ChannelDetailsView, null),
                React.createElement(BlankStateView, null)))));
};
const Chat = {
    component: ChatTool,
    icons: {
        active: "general.textMessage",
        static: "general.outlinedTextMessage",
    },
    name: "Chat",
};

export { Chat };
//# sourceMappingURL=chat.js.map
